import React, { Component } from 'react';

class Label extends Component {
    render() {
        const { htmlFor, required, children, className = '', rightContent } = this.props;
        
        return (
            <div className="flex items-center justify-between">
                <label 
                    htmlFor={htmlFor} 
                    className={`text-sm font-semibold text-foreground ${className}`}
                >
                    <span>{children}</span>
                    {required && <span className="text-destructive ml-0.5">*</span>}
                </label>
                {rightContent && <div className="flex">{rightContent}</div>}
            </div>
        );
    }
}

Label.defaultProps = {
    required: false,
    className: ''
};

export default Label;

